import { getPickupTemplate } from './PickupTemplateGenerator';
import { getDeliveryTemplate } from './DeliveryTemplateGenerator';
import { getApplianceDeliveryTemplate } from './ApplianceDeliveryTemplateGenerator';

export const getFulfillmentTileModels = ({
  fulfillment,
  type,
  covidAlert,
  quantity,
  zipCode,
  storeId,
  itemId,
  storeName,
  channel,
  pricing,
  thresholds,
  setShowCheckAvailability,
  currentDeliveryFfm,
  shippingData,
  subscriptionEligible = false,
  preferSecondaryFFM = false,
  productType,
  isCartTiles
}) => {

  const shippingTemplate = getDeliveryTemplate({
    fulfillment,
    type,
    zipCode,
    storeId,
    quantity,
    itemId,
    setShowCheckAvailability,
    covidAlert,
    pricing,
    thresholds,
    currentDeliveryFfm,
    shippingData,
    subscriptionEligible,
    preferSecondaryFFM
  });

  const storeTemplate = getPickupTemplate({
    channel,
    itemId,
    covidAlert,
    fulfillment,
    type,
    quantity,
    storeName,
    pricing,
    thresholds,
    productType,
    isCartTiles
  });

  return [storeTemplate, shippingTemplate];

};

export const getMajorApplianceTileModels = ({
  applianceDeliveryData,
  fulfillment,
  type,
  covidAlert,
  quantity,
  itemId,
  storeName,
  channel,
  pricing,
  thresholds,
  productType
}) => {

  const shippingTemplate = getApplianceDeliveryTemplate({
    applianceDeliveryData,
    pricing
  });

  const storeTemplate = getPickupTemplate({
    channel,
    itemId,
    covidAlert,
    fulfillment,
    type,
    quantity,
    storeName,
    pricing,
    thresholds,
    productType
  });

  return [storeTemplate, shippingTemplate];

};
